import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
const RadioUnchecked = forwardRef(({ ...props }, ref) => {
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-hidden": ariaHidden, ...props, children: _jsx("circle", { cx: 8, cy: 8, r: 7.5, fill: "#fff", stroke: "#bbb", className: "RadioUnchecked-circle" }) }));
});
RadioUnchecked.displayName = 'RadioUnchecked';
export default RadioUnchecked;
//# sourceMappingURL=RadioUnchecked.js.map